import { render, staticRenderFns } from "./ModalDeleteStudent.vue?vue&type=template&id=05a266ac&scoped=true"
import script from "./ModalDeleteStudent.vue?vue&type=script&lang=js"
export * from "./ModalDeleteStudent.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteStudent.vue?vue&type=style&index=0&id=05a266ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a266ac",
  null
  
)

export default component.exports